import { render, staticRenderFns } from "./CatalogSection.vue?vue&type=template&id=3bdeb4a9&scoped=true&"
import script from "./CatalogSection.vue?vue&type=script&lang=js&"
export * from "./CatalogSection.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSection.vue?vue&type=style&index=0&id=3bdeb4a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdeb4a9",
  null
  
)

export default component.exports